'use strict';

export default function TextareaInput({ 
    className = 'textarea',
    value,
    onChange,
    ...props 
}) {
    return <React.Fragment>
        {props.label && <label>{props.label}</label>}
        <textarea value={value} onInput={(event) => onChange(event.target.value)} className={className} {...props} />
    </React.Fragment>
}